import { userNotification } from "@/utils/constants";
import { handleResponse, handleError } from "@/utils/functions";

export default (axios) => ({
  getUserNotificationList(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(userNotification.base, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  markAsSeenUserNotification(payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${userNotification.base}mark_as_seen/`, payload)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getNotificationCount() {
    return new Promise((resolve, reject) => {
      axios
        .get(`${userNotification.base}notification_count/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
});
